import { dayjs } from '@noor/lib';
import type { SearchOrder } from './schema';

/**
 * The hover card of an order that is still searching for a courier, as the
 * legacy tracking map showed it: merchant name + phone, `#display · id`, since
 * when it has been searching, and a click hint. Empty lines are dropped.
 */
export function searchOrderHint(order: SearchOrder): string[] {
  const since = order.created_at ? dayjs(order.created_at) : null;
  const ids = [`#${order.display_id}`, order.id].filter(
    (part) => part != null && part !== '',
  );
  return [
    order.vendor?.name,
    order.vendor?.phone,
    ids.join(' · '),
    since?.isValid() ? `Поиск с ${since.format('HH:mm · D MMM')}` : null,
    'Нажмите, чтобы открыть заказ',
  ].filter((line): line is string => Boolean(line));
}
